import { apiClient } from "../config";

async function resetPassword(requestData:any) {
  const res = await apiClient.post(`/admin/users/reset-password`, requestData);
  return res.data;
}

export default resetPassword;
